import './rendercartprop.scss'

type Prop={
    type:string,
    value:string
}

const RenderCartProp = ({ type, value }:Prop) => {

    function isHexColor(value: string): boolean {
  return /^#(?:[0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(
    value
  );
}


    return (<div className="rcartprop">
        {type === 'size' && (
            <div className="sizesPack">
                <div className={`eachSize`}>
                    {value}
                </div>

            </div>
        )}


        {type === 'color' && (
            <div className="colorPack">
                    <div className={`eachColor`}>
                        {isHexColor(value) && (<div className="colorbox" style={{ backgroundColor: value }}></div>)}

                        {!isHexColor(value) && (<div className='colortext'>{value}</div>)}
                    </div>
            </div>
        )}
    </div>)
}

export default RenderCartProp